import actionCreatorFactory from 'typescript-fsa';

const actionCreator = actionCreatorFactory("SideMenu");

// Specify payload shape as generic type argument.
export const setSideMenuEntry = actionCreator<{nextentry: string}>('SET_SIDE_MENU_ENTRY');
export const setSideMenuDropdownIsOpen = actionCreator<{isopen: boolean}>('SET_SIDE_MENU_DROPDOWN');
export const setSideMenuCollapse = actionCreator<{collapsed: boolean}>('SET_SIDE_MENU_Collapse');
